import { brandEntityId, BrandEntityId, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandUseVO.validationSchema()
  );

  constructor(readonly value: RoomBrandUse) {
    JsonSchemaValidator.assert(RoomBrandUseVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId"],
      properties: {
        roomId,
        brandId: brandEntityId
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandUse {
  roomId: RoomId;
  brandId: BrandEntityId;
}
